<!-- Backdrop -->
<div 
  *ngIf="isOpen" 
  class="drawer-backdrop" 
  [@fadeInOut]
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title">
  
  <!-- Drawer Container -->
  <div class="drawer-container" [@slideInOut] (click)="$event.stopPropagation()">
    
    <!-- Header Section -->
    <header class="drawer-header">
      <div class="header-content">
        <span class="drawer-title">{{ title }}</span>
        <button 
          class="close-btn"
          (click)="onClose()"
          aria-label="Close drawer"
          type="button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="m18 6-12 12"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>
    </header>

    <!-- Subtitle Section -->
    <div class="drawer-subtitle cursor" (click)="openPopover('optimizationSummary')">
      <div class="subtitle-content">
        <span class="subtitle-text">{{ subtitle }}</span>
      </div>
    </div>

    <!-- Content Section -->
    <div class="drawer-content">
      <!-- Empty State -->
      <div *ngIf="tripData.length === 0" class="empty-state">
        <svg class="empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 6v6l4 2"></path>
        </svg>
        <p class="empty-text">No trip data available</p>
      </div>

      <!-- Trip Items List -->
      <ul *ngIf="tripData.length > 0" class="trip-list" role="list">
        <li 
          *ngFor="let item of tripData; trackBy: trackByFn; let i= index" 
          class="trip-item"
          role="listitem">
          <button 
            class="trip-button"
            (click)="onItemClick(item, item?.tripLabel, 'tripSegment')"
            (mouseenter)="emitHover(item)"
            (mouseleave)="emitHover(null)"
            [attr.aria-label]="'Trip item ' + item.tripId + ' at ' + item.dataFrom"
            type="button">
            <div class="trip-icon">
              <img *ngIf="item.icon" [src]="item.icon" [alt]="'Icon for ' + item.id" class="custom-icon">
            </div>
            <div class="trip-details">
              <span class="trip-id">{{ item?.tripLabel ?? 'Trip' }}</span>
              <span class="trip-time">{{ item.dataFrom | date: 'hh:mm a' }}</span>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>